import { useState, useRef } from "react";

export function HoverCard({ trigger, children }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const show = () => {
    if (!ref.current) return;
    setOpen(true);
  };

  const hide = () => setOpen(false);

  return (
    <div className="relative w-full ">
      <span ref={ref} onMouseEnter={show} onMouseLeave={hide} className="">
        {trigger}
      </span>
      {open && (
        <div
          onMouseEnter={show}
          onMouseLeave={hide}
          className="absolute z-50 bg-white shadow-xl border rounded-lg p-3 top-10 left-10"
        >
          {children}
        </div>
      )}
    </div>
  );
}
